import AccessibleTabWidget from "../../../accessibility/tabWidget";

export class ShopByVehicle {
  /*sets default tab and element-order values based on user device and tab visibility settings*/
  private readonly tabButtonSelector: string = "data-homepage-search-tab-pane";
  private readonly filterTabContent: HTMLElement = document.querySelector(
    `[${this.tabButtonSelector}="filter"]`
  );
  private readonly keywordTabContent: HTMLElement = document.querySelector(
    `[${this.tabButtonSelector}="keyword"]`
  );
  private readonly budgetTabContent: HTMLElement = document.querySelector(
    `[${this.tabButtonSelector}="budget"]`
  );
  private readonly isMobile: boolean =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(
      navigator.userAgent
    );
  private readonly tabList: HTMLElement = document.getElementById(
    "shopByVehicleSearchNav"
  );
  private readonly activeTab: HTMLElement =
    this.tabList.querySelector(".active");

  public constructor() {
    const searchNavBtns = document.querySelectorAll(
      ".shop-by-vehicle__search .search-nav .search-nav__btn"
    );
    searchNavBtns.forEach((btn: HTMLButtonElement) => {
      this.addButtonIconImages(btn);
    });
    this.setDefaultTabForDevice();
  }

  private checkForHiddenTabs() {
    if (this.isMobile) {
      this.getValidTabsAndTagOrder("desktop");
    } else {
      this.getValidTabsAndTagOrder("mobile");
    }
  }

  private getValidTabsAndTagOrder(deviceType: string) {
    const tabList = document.getElementById("shopByVehicleSearchNav");
    const tabs = Array.from(tabList.getElementsByClassName("nav-item"));
    const validTabs = [];
    let i = 0;
    for (const tab of tabs) {
      if (!tab.classList.contains(deviceType)) {
        (tab.children[0] as HTMLElement).dataset.dotaggingElementOrder =
          i.toString();
        validTabs.push(tab);
        i++;
      }
    }
    //if one of the tabs is hidden, adjust style
    if (i < 2) {
      this.tabList.style.justifyContent = "center";
    }
    return validTabs;
  }

  private setNewActiveTab(deviceType: string) {
    const validTabs = this.getValidTabsAndTagOrder(deviceType);
    const newActiveTab = validTabs[0];
    newActiveTab.classList.add("active");
    AccessibleTabWidget.setNewDefaultActiveTab(newActiveTab.children[0]);
    const tab = newActiveTab.children[0].dataset.homepageSearchTab;
    const newActivePanel = document.querySelector(
      `[data-homepage-search-tab-pane="${tab}"]`
    );
    newActivePanel?.classList.add("active");
    newActivePanel.removeAttribute("hidden");
  }

  private setDefaultTabForDevice() {
    const shouldHideActiveTab =
      (this.isMobile && this.activeTab.classList.contains("desktop")) ||
      (!this.isMobile && this.activeTab.classList.contains("mobile"));

    if (shouldHideActiveTab) {
      this.activeTab.classList.remove("active");
      this.tabList.style.justifyContent = "center";

      const panelId = this.activeTab.children[0].getAttribute("aria-controls");
      const panel = document.getElementById(panelId);
      panel?.classList.remove("active");
      panel?.setAttribute("hidden", "true");

      this.setNewActiveTab("desktop");
    }
    this.checkForHiddenTabs();
  }

  private addButtonIconImages(btn: HTMLButtonElement) {
    const navBtnIcon = btn.querySelector(".search-nav__img") as HTMLElement;
    const iconUrl = btn.dataset.iconUrl;
    navBtnIcon.style["-webkit-mask-image"] = `url(${iconUrl}`;
  }
}
